<div class="row justify-content-center">
  <div class="col-lg-6 btn-toolbar m-3 justify-content-between" role="toolbar">
    <div class="btn-group" role="group" aria-label="Button group">
      <button class="btn btn-primary" (click)="carousel.prev()" type="button">Previous</button>
      <button class="btn btn-primary" (click)="carousel.next()" type="button">Next</button>
    </div>
    <div class="btn-group" role="group" aria-label="Button group">
      <button class="btn btn-secondary" type="button"
        (click)="displayCaption = !displayCaption">{{(displayCaption) ? "Hide" : "Show"}} Caption</button>
    </div>
  </div>
</div>
<ngb-carousel #carousel [showNavigationArrows]="true" [showNavigationIndicators]="false" [interval]="0" *ngIf="images">
  <ng-template ngbSlide *ngFor="let image of images">
    <img onError="this.className='broken-image';" class="carousel-image" src="{{image.url}}" alt="">
    <div *ngIf="displayCaption" class="carousel-caption d-none d-sm-block">
      <h4 *ngIf="image.title">{{image.title}}</h4>
    </div>
  </ng-template>
</ngb-carousel>
